import { render, staticRenderFns } from "./globalNewParams.vue?vue&type=template&id=e9d29406&scoped=true"
import script from "./globalNewParams.vue?vue&type=script&lang=js"
export * from "./globalNewParams.vue?vue&type=script&lang=js"
import style0 from "./globalNewParams.vue?vue&type=style&index=0&id=e9d29406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_30effc9705e4bf7ead9172d765b7e483/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d29406",
  null
  
)

export default component.exports